import { CartImpressionTrackingInfoItem } from "@omni/types/components/tracking/tracking-info/impression/cartImpression.trackingInfo";

import { EnrichedAnalyticsEvent } from "@/utils/analytics/analytics.types";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo
} from "../GoogleAnalyticsMinimumDataset";
import {
    GoogleAnalyticsProduct,
    getGoogleAnalyticsProduct
} from "./GoogleAnalyticsProduct";

export interface GoogleAnalyticsAddToCartImpression
    extends GoogleAnalyticsMinimumDataset {
    ecommerce: {
        currencyCode: string;
        add: {
            products: GoogleAnalyticsProduct[];
        };
    };
}

const getGoogleAnalyticsAddToCartImpression = (
    data: EnrichedAnalyticsEvent<CartImpressionTrackingInfoItem>
): GoogleAnalyticsAddToCartImpression => {
    const googleAnalyticsCommerce: GoogleAnalyticsProduct =
        getGoogleAnalyticsProduct(data.payload.eventData);

    return {
        event: GoogleAnalyticsEvents.ProductAddToCart,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data),
        ecommerce: {
            currencyCode: data.payload.eventData.currencyCode,
            add: {
                products: [
                    {
                        ...googleAnalyticsCommerce,
                        quantity: data.payload.eventData.quantity
                    }
                ]
            }
        }
    };
};

export { getGoogleAnalyticsAddToCartImpression };
